// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";
import RailsNestedForm from "@stimulus-components/rails-nested-form";
application.register("nested-form", RailsNestedForm);
import {
  Alert,
  Autosave,
  ColorPreview,
  Modal,
  Tabs,
  Popover,
  Toggle,
  Slideover,
} from "tailwindcss-stimulus-components";
import DropdownController from "./dropdown_controller";
application.register("alert", Alert);
application.register("autosave", Autosave);
application.register("color-preview", ColorPreview);
application.register("dropdown", DropdownController);
application.register("modal", Modal);
application.register("popover", Popover);
application.register("slideover", Slideover);
application.register("tabs", Tabs);
application.register("toggle", Toggle);

import { Confetti } from "stimulus-confetti";
application.register("confetti", Confetti);

import CssController from "./css_controller";
application.register("css", CssController);

import AttributeController from "./attribute_controller";
application.register("attribute", AttributeController);

import DatePickerController from "./date_picker_controller";
application.register("date-picker", DatePickerController);

import FormController from "./form_controller";
application.register("form", FormController);

import TomSelectController from "./tom_select_controller";
application.register("tom-select", TomSelectController);

import TomCheckboxController from "./tom_checkbox_controller";
application.register("tom-checkbox", TomCheckboxController);

import TomCreateController from "./tom_create_controller";
application.register("tom-create", TomCreateController);

import InterventionSelectController from "./intervention_select_controller";
application.register("intervention-select", InterventionSelectController);

import SurfacingStudentsTabController from "./surfacing_students_tab_controller";
application.register("surfacing-students-tab", SurfacingStudentsTabController);

import TriageChartController from "./triage_chart_controller";
application.register("triage-chart", TriageChartController);

import EnergyLevelsChartController from "./energy_levels_chart_controller";
application.register("energy-levels-chart", EnergyLevelsChartController);

import EmotionsChartController from "./emotions_chart_controller";
application.register("emotions-chart", EmotionsChartController);

import AutoRefreshController from "./auto_refresh_controller";
application.register("auto-refresh", AutoRefreshController);

import MorphPreserveController from "./morph_preserve_controller";
application.register("morph-preserve", MorphPreserveController);

import NeedsChartController from "./needs_chart_controller";
application.register("needs-chart", NeedsChartController);

import CustomQuestionChartController from "./custom_question_chart_controller";
application.register("custom-question-chart", CustomQuestionChartController);

import ProgressMonitoringChartController from "./progress_monitoring_chart_controller";
application.register(
  "progress-monitoring-chart",
  ProgressMonitoringChartController,
);

import ClassroomsController from "./classrooms_controller";
application.register("classrooms", ClassroomsController);

import CharacterCounter from "@stimulus-components/character-counter";
application.register("character-counter", CharacterCounter);

import DestroyController from "./destroy_controller";
application.register("destroy", DestroyController);

import CheckboxSelectAll from "@stimulus-components/checkbox-select-all";
application.register("checkbox-select-all", CheckboxSelectAll);

import TextareaAutogrow from "stimulus-textarea-autogrow";
application.register("textarea-autogrow", TextareaAutogrow);

import LocaltimeController from "./localtime_controller";
application.register("localtime", LocaltimeController);

import ChatFormController from "./chat_form_controller";
application.register("chat-form", ChatFormController);

import ResetFromController from "./reset_form_controller";
application.register("reset-form", ResetFromController);

import ScrollController from "./scroll_controller";
application.register("scroll", ScrollController);

import ReadNotificationController from "./read_notification_controller";
application.register("read-notification", ReadNotificationController);
import ResponsiveFrameController from "./responsive_frame_controller";
application.register("responsive-frame", ResponsiveFrameController);

import StudentMessageController from "./student_message_controller";
application.register("student-message", StudentMessageController);

import FilterController from "./filter_controller";
application.register("filter", FilterController);

import NotificationsBadgeController from "./notifications_badge_controller";
application.register("notifications-badge", NotificationsBadgeController);

import PaginatedFormController from "./paginated_form_controller";
application.register("paginated-form", PaginatedFormController);

import ParentPostMessageController from "./parent_post_message_controller";
application.register("parent-post-message", ParentPostMessageController);

import SidebarController from "./sidebar_controller";
application.register("sidebar", SidebarController);

import MessageDraftController from "./message_draft_controller";
application.register("message-draft", MessageDraftController);

// Hotwire combobox
import HwComboboxController from "@josefarias/hotwire_combobox";
application.register("hw-combobox", HwComboboxController);

import EmotionIntensityRangeController from "./emotion_intensity_range_controller";
application.register(
  "emotion-intensity-range",
  EmotionIntensityRangeController,
);

import FlipController from "./flip_controller";
application.register("flip", FlipController);

import CircularController from "./circular_controller";
application.register("circular", CircularController);

import SensationFormController from "./sensation_form_controller";
application.register("sensation-form", SensationFormController);

import EmotionIntensityController from "./emotion_intensity_controller";
application.register("emotion-intensity", EmotionIntensityController);

import CheckboxGroupValidationController from "./checkbox_group_validation_controller";
application.register(
  "checkbox-group-validation",
  CheckboxGroupValidationController,
);

import CheckInFocusController from "./check_in_focus_controller";
application.register("check-in-focus", CheckInFocusController);

import RadioCardController from "./radio_card_controller";
application.register("radio-card", RadioCardController);

import BodyPartSelectionController from "./body_part_selection_controller";
application.register("body-part-selection", BodyPartSelectionController);

import AudioController from "./audio_controller";
application.register("audio", AudioController);

import VoiceoverController from "./voiceover_controller";
application.register("voiceover", VoiceoverController);

import MadlibsController from "./madlibs_controller";
application.register("madlibs", MadlibsController);

import MatrixChartController from "./matrix_chart_controller";
application.register("matrix-chart", MatrixChartController);

import TypeformController from "./typeform_controller";
application.register("typeform", TypeformController);

import TypeformPreviewController from "./typeform_preview_controller";
application.register("typeform-preview", TypeformPreviewController);

import CaseloadController from "./caseload_controller";
application.register("caseload", CaseloadController);

import AutoConfettiController from "./auto_confetti_controller";
application.register("auto-confetti", AutoConfettiController);

import StudentResourceAssignmentFormController from "./student_resource_assignment_form_controller";
application.register(
  "student-resource-assignment-form",
  StudentResourceAssignmentFormController,
);

import TitleChangeController from "./title_change_controller";
application.register("title-change", TitleChangeController);

import NpsSurveyController from "./nps_survey_controller";
application.register("nps-survey", NpsSurveyController);

import SchoolSearchController from "./school_search_controller";
application.register("school-search", SchoolSearchController);

import NameSwapController from "./name_swap_controller";
application.register("name-swap", NameSwapController);

import CleverSyncProgressController from "./clever_sync_progress_controller";
application.register("clever-sync-progress", CleverSyncProgressController);

import QuickClassroomMethodController from "./quick_classroom_method_controller";
application.register("quick-classroom-method", QuickClassroomMethodController);

import QuickClassroomStepsController from "./quick_classroom_steps_controller";
application.register("quick-classroom-steps", QuickClassroomStepsController);

import student_join_controller from "./student_join_controller";
application.register("student-join", student_join_controller);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import InstrumentFormController from "./instrument_form_controller";
application.register("instrument-form", InstrumentFormController);

import InstrumentAssignmentController from "./instrument_assignment_controller";
application.register("instrument-assignment", InstrumentAssignmentController);


import DemoModelPickerController from "./demo_model_picker_controller";
application.register("demo-model-picker", DemoModelPickerController);

import BrowserCheckInController from "./browser_check_in_controller";
application.register("browser-check-in", BrowserCheckInController);

import ConversationController from "./conversation_controller";
application.register("conversation", ConversationController);

import NeedsDemoPollController from "./needs_demo_poll_controller";
application.register("needs-demo-poll", NeedsDemoPollController);

import DemoReviewController from "./demo_review_controller";
application.register("demo-review", DemoReviewController);
